export default __webpack_public_path__ + "static/media/shivam.2d7b4d12.JPG";